var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-s-modal",
    {
      ref: "optionsModal",
      attrs: {
        id: "options-modal",
        "hide-footer": true,
        centered: false,
        size: "lg"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v("\n        Standard Options\n    ")
      ]),
      _vm._v(" "),
      _c(
        "b-tabs",
        _vm._l(_vm.groupedOptions, function(options, groupName) {
          return _c("b-tab", { key: groupName, attrs: { title: groupName } }, [
            _c(
              "ul",
              _vm._l(options, function(option) {
                return _c("li", { key: option.value }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(option.value) +
                      "\n                "
                  )
                ])
              }),
              0
            )
          ])
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }